import type { User } from '../../types/GroupsArrayType';

type Result = {
  [key in string]: number;
};
const consolidateTotals = (user: User): Result => {
  return ['totals', 'foreignTotals'].reduce((agg, totals) => {
    if (!agg) {
      return { ...user[totals] };
    }

    Object.keys(agg).forEach((prop) => (agg[prop] += user[totals][prop] || 0));
    return agg;
  }, null);
};

export default consolidateTotals;
